import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../../localization/language';

class UserInfo extends React.Component {
	render() {
		return (
			<div className="msidebar-user">
				<div className="msidebar-user__bg" style={{backgroundImage: 'url(' + this.props.userInfo.avatar + ')'}}></div>
				<div className="msidebar-user-i">
					<div className="msidebar-user__info">
						<img src={this.props.userInfo.avatar} alt="" className="msidebar-user__info-thumb"></img>
						<div className="msidebar-user__info-desc">
							<div className="msidebar-user__info-name">
								{this.props.userInfo.username}
							</div>
							<div className="msidebar-user__info-location">
								{this.props.userInfo.uid}
							</div>
						</div>
					</div>
					<div className="msidebar-user__state">
						<div className="msidebar-user__state-item">
							<div className="msidebar-user__state-icon--shell"></div>
							<div className="msidebar-user__state-txt">
								{this.props.userInfo.shell}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(UserInfo);


// WEBPACK FOOTER //
// ./app/components/mobile/UserInfo.js